import { render } from "./B2bFilterButtonRemadv.vue?vue&type=template&id=2f0dc3ef&scoped=true&lang=pug"
import script from "./B2bFilterButtonRemadv.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonRemadv.vue?vue&type=script&lang=js"

import "./B2bFilterButtonRemadv.vue?vue&type=style&index=0&id=2f0dc3ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0dc3ef"]])

export default __exports__